<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات عضله"
        >
          <b-form
            ref="muscleform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <div class="">
                        <b-form-group
                          label="عنوان"
                          label-for="Title"
                          class="mb-0"
                        >
                          <b-form-input
                            id="Title"
                            v-model="Form.Title"
                            name="Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </div>
                    </b-media>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.MuscleLanguage"
                      :key="index"
                    >

                      <b-col cols="12">
                        <hr>
                      </b-col>

                      <b-col md="5">
                        <b-form-group>
                          <label>زبان:</label>
                          <z-language
                            v-model="item.Language"
                            :unselectable="Form.MuscleLanguage.map(x => x.Language)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="عنوان"
                        >
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="MuscleLanguageRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeMuscleLanguage(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelMuscleLanguage"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmMuscleLanguage"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addMuscleLanguage"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'ActivityCategoryDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        MuscleLanguage: [],
      },
      MuscleLanguageRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addMuscleLanguage()
    }
  },
  methods: {
    save() {
      let url = this.$api.muscle.add
      if (this.$route.params.id) {
        url = this.$api.muscle.update
      }

      const formData = new FormData(this.$refs.muscleform)
      formData.append('Id', this.Form.Id)

      this.Form.MuscleLanguage.forEach((item, index) => {
        if (typeof (item.Language) === 'number') {
          formData.append(`MuscleLanguage[${index}].Language`, item.Language)
          formData.append(`MuscleLanguage[${index}].Title`, item.Title)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.muscle.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addMuscleLanguage() {
      this.Form.MuscleLanguage.push({ Title: null, Language: null })
    },
    removeMuscleLanguage(index) {
      this.MuscleLanguageRemoveId = index
    },
    confirmMuscleLanguage() {
      this.Form.MuscleLanguage.splice(this.MuscleLanguageRemoveId, 1)
      this.MuscleLanguageRemoveId = null
    },
    cancelMuscleLanguage() {
      this.MuscleLanguageRemoveId = null
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
